<template>
  <vue-modal no-close ref="modal" class="messag-modal">
    <template v-slot:default>
      <div class="container-modal">
        <div class="text">{{ MESSAGE_MODAL }}</div>
      </div>
      <vue-button 
        type="button"
        @click="clearMessage"
        cls="main">Close</vue-button>
    </template>
  </vue-modal>
</template>

<script>
import { mapGetters } from "vuex";
// import PreLoader from "@/components/UI/PreLoader";
import VueModal from "@/components/UI/VueModal";
import VueButton from "@/components/UI/VueButton";

export default {
  name: "MessageModal",
  components: {
    // PreLoader,
    VueModal,
    VueButton,
  },
  props: {
    message: {
      type: String
    },
    
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapGetters(['MESSAGE_MODAL']),
  },
  watch: {
    MESSAGE_MODAL() {
      this.initPopupState()
    }
  },
  mounted() {
    this.initPopupState()
  },
  methods:{
    initPopupState() {
      if (this.MESSAGE_MODAL) {
        this.$refs.modal.open()
      }
      else{
        this.close()
      }
    },
    clearMessage() {
      this.$store.dispatch('SET_MESSAGE_MODAL', null)
    },
    close() {
      this.$refs.modal.close()
    }

  }
}
</script>

<style scoped lang="scss">
  .messag-modal {
    z-index: 1200;
  }
  .content{
    max-width: 400px;
  }

  .container-modal {
    margin: 0;
    max-width: 60vw;
    @media only screen and (max-width: 1024px){
      max-width: unset;
    }

    .text {
      margin-bottom: 2.5rem;
      text-align: center;
      white-space: pre-line;
    }
  }
</style>